import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import NotFound from "./pages/NotFound";
import Login from "./pages/login";
import ForgotPasswordPage from "./pages/forgot-password/page";
import EnterCodePage from "./pages/enter-code/page";
import ResetPasswordPage from "./pages/reset-password/page";
import ProtectedRoute from "./share/protected-route/ProtectedRoute";
import I18nProvider from "./lib/i18n-provider";
import MainLayout from "./share/layouts/MainLayout";
import Therapy from "./pages/therapy";
import ExerciseListPage from "./pages/exercises/exercise-list/page";
import ExerciseDetail from "./pages/exercises/exercises-detail/page";
import QuestionsPage from "./pages/exercises/questions/page";
import Messages from "./pages/messages/page";
import Consultation from "./pages/consultation/page";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import JoinForm from "./pages/join-form/page";
import ProfilePage from "./pages/profile/page";
import LanguagePage from "./pages/profile/language";
import ChangePasswordPage from "./pages/profile/change-password";
import FeedbackPage from "./pages/exercises/feedback/page";

function App() {
  return (
    <I18nProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Toaster position="top-right" />
          <Routes>
            {/* element dont need layout */}
            <Route element={<ProtectedRoute />}>
              <Route element={<MainLayout />}>
                <Route path="/" element={<Therapy />} />
                <Route path="/consultation" element={<Consultation />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/exercise-list" element={<ExerciseListPage />} />
                <Route path="/join-form" element={<JoinForm />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/profile/language" element={<LanguagePage />} />
                <Route
                  path="/profile/change-password"
                  element={<ChangePasswordPage />}
                />
                <Route
                  path="/exercise/:exerciseId"
                  element={<ExerciseDetail />}
                />
                <Route
                  path="/exercise/questions/:id"
                  element={<QuestionsPage />}
                />
                <Route
                  path="/exercise/feedback/:id"
                  element={<FeedbackPage />}
                />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Route>

            {/* element need layout */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/enter-code" element={<EnterCodePage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </I18nProvider>
  );
}

export default App;
